import * as React from 'react'
import * as Sentry from '@sentry/react'
import { StyleSheetManager } from 'styled-components'
import AppLoader from '../components/Loaders/AppLoader';
import { Provider } from 'react-redux';
import store from './store';
import App, { AppClass } from './containers/App';
import { BizzeySetting } from '../../packs/widget_shim';
import { MemoryRouter as Router } from 'react-router-dom';
import { SENTRY_DSN } from '../Constants';

Sentry.init({ dsn: SENTRY_DSN, })

interface IProps {
  settings?: BizzeySetting
  ref: React.RefObject<AppClass>
}

const Application = (props: IProps, ref) => {
  const { settings } = props

  return (
    <React.Suspense fallback={<AppLoader />}>
      <Provider store={store}>
        <StyleSheetManager>
          <Router>
            <App
              ref={ref}
              settings={settings}
            />
          </Router>
        </StyleSheetManager>
      </Provider>
    </React.Suspense>
  )
}

export default React.forwardRef(Application)